import { assign } from 'lodash';

import * as Canvas3d from '../ui/canvas3d';

let { Cx } = window;

assign( Cx, Canvas3d );



/** WEBPACK FOOTER **
 ** ./src/web/canvas3d.js
 **/